import { render, staticRenderFns } from "./FrameworkAdminUserEdit.vue?vue&type=template&id=0367fb26"
import script from "./FrameworkAdminUserEdit.vue?vue&type=script&lang=js"
export * from "./FrameworkAdminUserEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports